import React from 'react';
import { useState, useEffect } from 'react';
import './classes/Testimonials.css';
import { configData } from "../config";
import { getGlobalValue } from './PageEditor/globalContentStore';

const Testimonials = ({page}) => {
  const app_url = configData.APP_URL;
  const [content, setContent] = useState([]);

useEffect(() => {
    // setContent([
    //   { name: 'Raymond Haija', 
    //     content: 'NFL & CFL Agent', 
    //     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw', 
    //     link: "#", 
    //     position: "Influencer and Affiliate Marketing Manager" },
    //   { name: 'Donovan Phillips', 
    //     content: "I highly recommend SMWW's Athlete Branding and Marketing course. This course afforded me the opportunity to learn from the best...", 
    //     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw', 
    //     link: "#" }
    // ]);
if(page?.nid) {
gettestimonial(page.nid);
}
}, [page]);
const gettestimonial = async (nid) => {
    try {
     
      const postData = {
           nid: nid,
           
          };
          try {
            const response = await fetch(app_url + 'coursepages/gettestimonial', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setContent(data.data.result);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
// Some testimonials have no usable picture: show the "not available" image instead of a broken one
const placeholderImg = configData.DRUPAL_DOMAIN_URL + '/sites/person_images/notavailable.jpg';
const showPlaceholder = (event) => {
    if (event.currentTarget.src !== placeholderImg) {
      event.currentTarget.src = placeholderImg;
    }
};
  // As on the live site, the block is left out when there is nothing to list
  if (!content.length) return null;
  return (
    <div className="course-testimonial-container">
      <h2 className="testimonial-title">{getGlobalValue('testimonials_heading')}</h2>
        <ul>
            {content.map((story, idx) => (<>
                <li key={idx} className="success-box-list">
                  <div className='success-profile'>
                    <img src={story.img} alt={story.title} className="success-img" onError={showPlaceholder} />
                    <div className="testimonial-top-content">
                        <a href={story.link} className="mentor-name-link">{story.title}</a>
                        {story.author_title && <div className="testimonial-position">{story.author_title}</div>}
                    </div>
                  </div>
                  <p className="testimonial-quote" dangerouslySetInnerHTML={{
                    __html:story.content
                }}></p>
                </li>
            </>))}
        </ul>

    </div>
  );
};
export default Testimonials;